import { Injectable } from '@angular/core';
import { RestService } from '../../../services/rest.service';

/** Minimal, token-scoped view of an order returned to the public pay page. */
export interface PublicOrderView {
  organisationName: string | null;
  planName: string | null;
  period: string;
  amount: number;
  orderStatus: string;
  instantActivation: boolean;
  paymentDueDate: string | null;
  razorpayShortUrl: string | null;
}

/**
 * Public (no-auth) access to an order via its shareable payment-link token.
 * Backs the `/pay/:token` page used by clients who received an admin-generated link.
 */
@Injectable({
  providedIn: 'root',
})
export class OrderPublicApiService {

  static readonly ApiUrl: string = 'order/public';

  constructor(private restService: RestService) { }

  async getByToken(token: string): Promise<PublicOrderView> {
    return (await this.restService.send<PublicOrderView>({
      url: `${OrderPublicApiService.ApiUrl}/${token}`,
      method: 'GET',
      throwError: true,
    })).data;
  }
}
